export default __webpack_public_path__ + "static/easyboardImage-ae0911bf8be3e32d535410fe64fac2a9.jpg";